import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'keywordFilter',
    standalone: false
})
export class KeywordFilterPipe implements PipeTransform {
  transform(input: any[], toMatch: string, key?: string): any[] {
    key = key ? key : 'language_long';
    if (toMatch) {
      // console.log( '::: PIPE ::: ', input, key )
      input = input.filter(item => item[key].toLowerCase().indexOf(toMatch.toLowerCase()) > -1);
    }

    return input;
  }
}
